var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "designer" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "px-1 px-sm-3",
              attrs: { lg: "8", order: "2", "order-lg": "1" },
            },
            [
              _c(
                "b-tabs",
                {
                  attrs: { card: "", fill: "" },
                  model: {
                    value: _vm.currentTab,
                    callback: function ($$v) {
                      _vm.currentTab = $$v
                    },
                    expression: "currentTab",
                  },
                },
                [
                  _c(
                    "b-tab",
                    {
                      staticClass: "designer-tab",
                      attrs: { "no-body": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [_vm._v("Size")]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "b-card-body",
                        { staticClass: "px-0 px-sm-3" },
                        [
                          _c("artwork-size", {
                            on: {
                              "next-tab": function ($event) {
                                _vm.currentTab++
                              },
                              "upload-image": _vm.onQuickUploadImage,
                            },
                            model: {
                              value: _vm.frame.size,
                              callback: function ($$v) {
                                _vm.$set(_vm.frame, "size", $$v)
                              },
                              expression: "frame.size",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-tab",
                    {
                      staticClass: "designer-tab",
                      attrs: { "no-body": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [_vm._v("Frames")]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "b-card-body",
                        { staticClass: "px-0 px-sm-3" },
                        [
                          _vm.hasVisitedTab(_vm.Tabs.MouldingOptions)
                            ? _c("moulding-options", {
                                attrs: {
                                  "rebate-dimensions": _vm.rebateDimensions,
                                  "non-frame-price": _vm.nonFramePrice,
                                },
                                on: {
                                  "prev-tab": function ($event) {
                                    _vm.currentTab--
                                  },
                                  "next-tab": function ($event) {
                                    _vm.currentTab++
                                  },
                                },
                                model: {
                                  value: _vm.frame.moulding,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.frame, "moulding", $$v)
                                  },
                                  expression: "frame.moulding",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-tab",
                    {
                      staticClass: "designer-tab",
                      attrs: { "no-body": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [_vm._v("Mounts")]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "b-card-body",
                        { staticClass: "px-0 px-sm-3" },
                        [
                          _vm.hasVisitedTab(_vm.Tabs.MountOptions)
                            ? _c("mount-options", {
                                attrs: {
                                  "rebate-dimensions": _vm.rebateDimensions,
                                },
                                on: {
                                  "prev-tab": function ($event) {
                                    _vm.currentTab--
                                  },
                                  "next-tab": function ($event) {
                                    _vm.currentTab++
                                  },
                                },
                                model: {
                                  value: _vm.frame.mount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.frame, "mount", $$v)
                                  },
                                  expression: "frame.mount",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-tab",
                    {
                      staticClass: "designer-tab",
                      attrs: { "no-body": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [_vm._v("Glazings")]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "b-card-body",
                        { staticClass: "px-0 px-sm-3" },
                        [
                          _vm.hasVisitedTab(_vm.Tabs.GlazingOptions)
                            ? _c("glazing-options", {
                                attrs: {
                                  "rebate-dimensions": _vm.rebateDimensions,
                                  "has-mount": _vm.frame.mount.type != "none",
                                },
                                on: {
                                  "prev-tab": function ($event) {
                                    _vm.currentTab--
                                  },
                                  "next-tab": function ($event) {
                                    _vm.currentTab++
                                  },
                                },
                                model: {
                                  value: _vm.frame.glazing,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.frame, "glazing", $$v)
                                  },
                                  expression: "frame.glazing",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-tab",
                    {
                      staticClass: "designer-tab",
                      attrs: { title: "Extras", "no-body": "" },
                    },
                    [
                      _c(
                        "b-card-body",
                        { staticClass: "px-0 px-sm-3" },
                        [
                          _vm.hasVisitedTab(_vm.Tabs.FrameExtras)
                            ? _c("frame-extras", {
                                attrs: {
                                  "rebate-dimensions": _vm.rebateDimensions,
                                  glazing: _vm.frame.glazing,
                                },
                                on: {
                                  "prev-tab": function ($event) {
                                    _vm.currentTab--
                                  },
                                  "next-tab": function ($event) {
                                    _vm.currentTab++
                                  },
                                },
                                model: {
                                  value: _vm.frame.extras,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.frame, "extras", $$v)
                                  },
                                  expression: "frame.extras",
                                },
                              })
                            : _vm._e(),
                          _c("h4", { staticClass: "mt-5" }, [
                            _vm._v("Additional Products"),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                "- Optionally, add some of our other products to your order"
                              ),
                            ]),
                          ]),
                          _c("p", [
                            _vm._v(
                              "These extras are added directly to your cart, and not part of your current frame order."
                            ),
                          ]),
                          _vm.hasVisitedTab(_vm.Tabs.FrameExtras)
                            ? _c("frame-product-extras")
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-tab",
                    {
                      staticClass: "designer-tab",
                      attrs: { "no-body": "", lazy: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _vm._v("Review "),
                              _c(
                                "span",
                                { staticClass: "d-none d-sm-inline" },
                                [_vm._v("& Order")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c(
                        "b-card-body",
                        { staticClass: "px-0 px-sm-3" },
                        [
                          _c("review-order", {
                            attrs: {
                              frame: _vm.frame,
                              "rebate-dimensions": _vm.rebateDimensions,
                              prices: _vm.prices,
                              price: _vm.totalPrice,
                              "ex-vat-price": _vm.exVatTotalPrice,
                              "discounted-price": _vm.discountedPrice,
                              discount: _vm.discount,
                              "image-name": _vm.imageName,
                              "loading-prices": _vm.loading,
                              "is-admin": _vm.isAdmin,
                            },
                            on: {
                              "prev-tab": function ($event) {
                                _vm.currentTab--
                              },
                              "jump-tab": _vm.onJumpTab,
                            },
                            model: {
                              value: _vm.quantity,
                              callback: function ($$v) {
                                _vm.quantity = $$v
                              },
                              expression: "quantity",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "px-0 px-md-3",
              attrs: { lg: "4", order: "1", "order-lg": "2" },
            },
            [
              _c(
                "div",
                { staticClass: "sticky-top" },
                [
                  _c("frame-visualisation", {
                    attrs: {
                      sku: _vm.frame.moulding ? _vm.frame.moulding.sku : null,
                      "chevron-images": _vm.frame.moulding
                        ? _vm.frame.moulding.chevronImages
                        : null,
                      "rebate-dimensions": _vm.rebateDimensions,
                      "artwork-dimensions": _vm.frame.size,
                      "uploaded-image-name": _vm.imageName,
                      mount: _vm.frame.mount,
                      backing: _vm.frame.extras.backing,
                      "frame-errors": _vm.frameErrors,
                    },
                  }),
                  _c("b-overlay", { attrs: { show: _vm.loading } }, [
                    _c(
                      "h2",
                      {
                        staticClass: "text-center my-3 pl-3",
                        attrs: { id: "price" },
                      },
                      [
                        _vm._v("Price: "),
                        _c("strong", [
                          _vm._v("£" + _vm._s(_vm.discountedPrice || "0.00")),
                        ]),
                        _vm._v(" each (" + _vm._s(_vm.vatMode) + " VAT)"),
                        _c("br"),
                        _c("small", { staticClass: "text-muted" }, [
                          _c("em", [
                            _vm._v(
                              "with " +
                                _vm._s(
                                  _vm.frame.glazing
                                    ? _vm.frame.glazing.name
                                    : "no glazing"
                                )
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c("moulding-sample-add-to-cart", {
                        attrs: {
                          sku: _vm.frame.moulding
                            ? _vm.frame.moulding.sku
                            : null,
                          "vat-mode": _vm.vatMode,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "text-center my-2" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-1 mb-1",
                          attrs: {
                            size: "sm",
                            variant: "info",
                            _target: "_blank",
                            disabled: !_vm.frame.moulding,
                            href: _vm.diyHref,
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons mr-1" }, [
                            _vm._v("handyman"),
                          ]),
                          _vm._v("DIY Options"),
                        ]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-1 mb-1",
                          attrs: {
                            size: "sm",
                            variant: "warning",
                            href: _vm.visualisationUrl,
                            download:
                              "Brampton Picture Framing - Frame Visualisation.jpg",
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons mr-1" }, [
                            _vm._v("file_download"),
                          ]),
                          _vm._v("Save"),
                        ]
                      ),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.image-upload",
                              modifiers: { "image-upload": true },
                            },
                          ],
                          staticClass: "mr-1 mb-1",
                          attrs: { size: "sm", variant: "danger" },
                        },
                        [
                          _c("span", { staticClass: "material-icons mr-1" }, [
                            _vm._v("upload_file"),
                          ]),
                          _vm._v("Upload Image"),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("frame-size-details", {
                    attrs: {
                      "artwork-dimensions": _vm.frame.size,
                      "rebate-dimensions": _vm.rebateDimensions,
                      "moulding-width": _vm.frame.moulding
                        ? _vm.frame.moulding.width_mm
                        : null,
                      "has-mount": _vm.frame.mount.type != "none",
                      "mount-borders": _vm.frame.mount.borders,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "image-upload",
            title: "Upload and Visualize your Artwork",
            size: "xl",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "hide-footer": "",
            static: "",
            scrollable: "",
          },
        },
        [
          _c("image-uploader", {
            attrs: { "rebate-dimensions": _vm.rebateDimensions },
            on: {
              "image-uploaded": _vm.onImageUpload,
              "image-removed": _vm.onImageRemove,
              rotate: _vm.onRotate,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }